import React from "react";
import PropTypes from "prop-types";
import Checkbox from "components/Common/Checkbox";
import InfoTooltip from "components/Common/InfoTooltip";
import "./style.scss";

const CheckboxPanel = ({
  label,
  handleToggle,
  checked,
  customClassName,
  children,
  showTooltip,
  tooltipMessage,
  tooltipPosition,
  tooltipImgPath,
  tooltipImgAltText,
  maxWidth
}) => {
  const iconDefault = "Info";
  const iconClicked = "InfoFilled";

  return (
    <div className={`CheckboxPanel ${customClassName}`}>
      <div className="CheckboxPanel__text">
        <h3 className="g-form__block__label CheckboxPanel__header">{label}</h3>
        <div className="CheckboxPanel__description g-form__block__description">
          {children}
        </div>
      </div>
      {showTooltip && (
        <div className="CheckboxPanel__infoTooltip">
          <InfoTooltip
            blurb={tooltipMessage}
            iconDefault={iconDefault}
            iconClicked={iconClicked}
            customPosition={tooltipPosition}
            tooltipImgPath={tooltipImgPath}
            tooltipImgAltText={tooltipImgAltText}
            absolute
            maxWidth={maxWidth}
          />
        </div>
      )}
      <div className="CheckboxPanel__toggle">
        <Checkbox
          checked={checked}
          className="CheckboxPanel__checkbox g-tile__checkbox"
          handleToggle={handleToggle}
          isSwitch
        />
      </div>
    </div>
  );
};


CheckboxPanel.propTypes = {
  label: PropTypes.string.isRequired,
  handleToggle: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  children: PropTypes.node,
  showTooltip: PropTypes.bool,
  tooltipMessage: PropTypes.string,
  tooltipPosition: PropTypes.shape({
    dimple: PropTypes.string,
    top: PropTypes.number,
    left: PropTypes.number,
    bottom: PropTypes.number,
    right: PropTypes.number
  }),
  customClassName: PropTypes.string,
  tooltipImgPath: PropTypes.string,
  tooltipImgAltText: PropTypes.string,
  maxWidth: PropTypes.number
};

CheckboxPanel.defaultProps = {
  customClassName: "",
  tooltipMessage: "",
  showTooltip: false,
  tooltipPosition: undefined,
  children: undefined,
  tooltipImgPath: "",
  tooltipImgAltText: "",
  maxWidth: 184
};

export default CheckboxPanel;
